// extracted by mini-css-extract-plugin
export var body = "styles-module--body--3On_F";
export var bold = "styles-module--bold--vz8S6";
export var brand = "styles-module--brand--16Drn";
export var centered = "styles-module--centered--1Bn87";
export var heading = "styles-module--heading--yWil5";
export var italic = "styles-module--italic--2xQeE";
export var large = "styles-module--large--3hSay";
export var light = "styles-module--light--2h0qu";
export var marginBottom = "styles-module--marginBottom--10fL5";
export var noMarginBottom = "styles-module--noMarginBottom--1vqW2";
export var sans = "styles-module--sans--3G2k0";
export var semibold = "styles-module--semibold--1yN4s";
export var serif = "styles-module--serif--xPZX1";
export var smSmall = "styles-module--smSmall--1ACjh";
export var small = "styles-module--small--1W_Ke";
export var title = "styles-module--title--2IwNb";
export var typography = "styles-module--typography--3H_qD";
export var uppercase = "styles-module--uppercase--1lljQ";
export var useParentFontWeight = "styles-module--useParentFontWeight--2ltvJ";
export var useParentSize = "styles-module--useParentSize--3uIN0";
export var white = "styles-module--white--1XJXa";